var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/list.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import classNames from 'classnames';
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Icon from './icon';
const List = ({
  children,
  className = ''
}) => /*#__PURE__*/React.createElement("div", {
  className: `${className} space-y-0.5`,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 3
  }
}, children);
const ListItem = ({
  label,
  hint,
  children,
  onClick,
  className
}) => {
  const id = uuidv4();
  const domId = `list-group-${id}`;
  const Comp = onClick ? 'a' : 'div';
  const LabelComp = onClick ? 'span' : 'label';
  const linkProps = onClick ? {
    onClick
  } : {};
  const renderChildren = React.useCallback(() => React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        id: domId
      });
    }
    return null;
  }), [children, domId]);
  return /*#__PURE__*/React.createElement(Comp, _extends({
    className: classNames({
      'flex items-center justify-between px-3 py-2 first:rounded-t-lg last:rounded-b-lg bg-gradient-to-r from-gradient-start/10 to-gradient-end/10 dark:from-slate-900/25 dark:to-slate-900/50': true,
      'cursor-pointer hover:from-gradient-start/20 hover:to-gradient-end/20 dark:hover:from-slate-900/40 dark:hover:to-slate-900/75': typeof onClick !== 'undefined',
      className
    })
  }, linkProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col py-1.5 pr-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(LabelComp, {
    className: "text-black dark:text-white",
    htmlFor: domId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 9
    }
  }, label), hint ? /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-500 dark:text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  }, hint) : null), onClick ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center text-gray-500 dark:text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, children, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/chevron-right.svg'),
    className: "ml-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  })) : renderChildren());
};
export { List as default, ListItem };